<app-header *ngIf="showHead"></app-header>
<app-toast></app-toast>

<div class="row" *ngIf="showSidebar">
  <div class="col-2">
    <app-sidebar></app-sidebar>
  </div>
  <div class="col-8" [ngClass]="{'col-10': !showrightbar}">
    <router-outlet></router-outlet>
  </div>
  <div class="col-2" *ngIf="showrightbar">
    <app-rightbar></app-rightbar>
  </div>
</div>

<router-outlet *ngIf="!showSidebar"></router-outlet>

<app-footer *ngIf="showHead"></app-footer>
